import FirestoreBaseService from './firestoreBase';

class StudentService extends FirestoreBaseService {
  constructor() {
    super('students');
  }

  /**
   * 学生IDで学生情報を取得
   * @param {string} studentId - 学生ID
   */
  async fetchStudentById(studentId) {
    try {
      console.log(`Fetching student with ID: ${studentId}`);
      const student = await this.get(studentId);
      console.log('Student data retrieved:', student);
      if (!student) {
        console.log('Student not found in students collection');
        throw new Error('Student not found');
      }
      return student;
    } catch (error) {
      console.error('Error fetching student by ID:', error);
      throw this.handleError(error);
    }
  }

  /**
   * 学生を作成
   * @param {string} studentId - 学生ID
   * @param {Object} studentData - 学生データ
   */
  async createStudent(studentId, studentData) {
    try {
      await this.createOrUpdate(studentId, studentData);
      return { success: true, studentId };
    } catch (error) {
      console.error('Error creating student:', error);
      throw this.handleError(error);
    }
  }

  /**
   * 学生情報を更新
   * @param {string} studentId - 学生ID
   * @param {Object} updateData - 更新データ
   */
  async updateStudent(studentId, updateData) {
    try {
      await this.update(studentId, updateData);
      return { success: true, studentId };
    } catch (error) {
      console.error('Error updating student:', error);
      throw this.handleError(error);
    }
  }

  /**
   * 複数の学生を取得（検索条件付き）
   * @param {Array} conditions - 検索条件
   * @param {number} limitCount - 取得件数制限
   */
  async getStudents(conditions = [], limitCount = null) {
    try {
      return await this.getMany(
        conditions,
        [{ field: 'createdAt', direction: 'desc' }],
        limitCount
      );
    } catch (error) {
      console.error('Error getting students:', error);
      throw this.handleError(error);
    }
  }

  /**
   * 学生の統計情報を取得
   */
  async getStudentStats() {
    try {
      const students = await this.getAll();
      
      // 大学別統計
      const universityStats = {};
      // 学年別統計
      const gradeStats = {};
      
      students.forEach(student => {
        // 大学統計
        const university = student.大学名 || '不明';
        universityStats[university] = (universityStats[university] || 0) + 1;
        
        // 学年統計
        const grade = student.学年 || '不明';
        gradeStats[grade] = (gradeStats[grade] || 0) + 1;
      });

      return {
        total: students.length,
        byUniversity: universityStats,
        byGrade: gradeStats
      };
    } catch (error) {
      console.error('Error getting student stats:', error);
      throw this.handleError(error);
    }
  }
}

// 既存の関数も互換性のためにエクスポート
const studentService = new StudentService();
export const fetchStudentById = studentService.fetchStudentById.bind(studentService);
export const updateStudent = studentService.updateStudent.bind(studentService);

export default studentService;